// extracted by mini-css-extract-plugin
module.exports = {"btn-group":"ButtonGroup_btn-group__8layv","dropdown-toggle":"ButtonGroup_dropdown-toggle__XJSLF"};